module.exports = __webpack_public_path__ + "img/6E2E36_D3A1A0_BD7175_C78C8B-256px.ad2f1cff.png";